import styled from "styled-components"
import { transparentize } from "polished"

const StyledResetButton = styled.button`
  z-index: 1;
  cursor: pointer;
  user-select: none;
  border-radius: 2px;
  height: 4rem;
  width: 4rem;
  box-shadow: ${({ theme }) => transparentize(0.7, theme.color.black)} 0px 1px
    4px -1px;
  background-color: ${({ theme }) => theme.color.white};
  border: none;
  margin: 1rem;
  outline: none;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.septenary03};
    outline-offset: 2px;
  }

  > svg {
    width: 100%;
    height: 100%;
  }
`

export { StyledResetButton }
